import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import { alpha, useTheme } from '@mui/material/styles';

// Icons for services
import DescriptionIcon from '@mui/icons-material/Description';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';

/**
 * Definitions of services offered.  Each entry contains the icon
 * component to render along with a title and description.  You can
 * extend or reorder this array as your offerings evolve.
 */
const services = [
  {
    icon: DescriptionIcon,
    title: 'Gestión Aduanera',
    desc: 'Trámites aduaneros integrales y documentación de comercio exterior.',
  },
  {
    icon: LocalShippingIcon,
    title: 'Transporte Terrestre',
    desc: 'Distribución nacional e internacional por carretera, asegurando entregas puntuales.',
  },
  {
    icon: DirectionsBoatIcon,
    title: 'Transporte Marítimo',
    desc: 'Soluciones para envíos marítimos internacionales, con consolidación de carga y seguimiento.',
  },
  {
    icon: FlightTakeoffIcon,
    title: 'Transporte Aéreo',
    desc: 'Envíos rápidos y seguros por vía aérea para cargas urgentes.',
  },
];

/**
 * Services section displaying a grid of offerings.  Each card has a
 * hover animation to subtly draw attention.  The section heading is
 * highlighted with a soft background for emphasis.
 */
const Services = () => {
  const theme = useTheme();
    const pearl = '#FFFFFF';
  const pearlGlass = alpha(pearl, 0.72);
  return (
     <Box id="servicios" sx={{ py: 8, bgcolor: 'background.default' }}>
      <Container>
        <Box sx={{ textAlign: 'center', mb: 6 }}>
              <Typography
            variant="h3"
            component="h2"
           sx={{
                display: 'block',
                px: 2,
                pt: 0.5,
                pb: 1.5,
                bgcolor: pearlGlass,
                color: 'text.primary',
                backdropFilter: 'blur(6px)',
                borderRadius: 1,
                fontWeight: 700,
              }}
          >
            Nuestros Servicios
          </Typography>
        </Box>
        <Grid container spacing={4}>
          {services.map((service) => (
            <Grid item xs={12} sm={6} md={3} key={service.title}>
              <Card
                sx={{
                  p: 3,
                  textAlign: 'center',
                  borderRadius: 3,
                  height: '100%',
                  boxShadow: 1,
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4,
                  },
                }}
              >
                <Box sx={{ color: 'primary.main', mb: 2 }}>
                  {React.createElement(service.icon, { fontSize: 'large' })}
                </Box>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  {service.title}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  {service.desc}
                </Typography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Services;